import axios from 'axios'
import baseInterceptor from './baseInterceptor'
import { getEnvVariable } from '@/helpers'

const AxiosIdentity = axios.create({
  baseURL: getEnvVariable('VUE_APP_IDENTITY_API_URL', process.env.VUE_APP_IDENTITY_API_URL),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  },
})


baseInterceptor(AxiosIdentity)

export default AxiosIdentity
/* eslint-enable no-param-reassign */
